"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Grid_1 = require("@mui/material/Grid");
var React = require("react");
var formik_1 = require("formik");
require("../OTP_Management/otp_management_styles.scss");
var system_configuration_api_calls_1 = require("./system_configuration_api_calls");
var material_1 = require("@mui/material");
var Edit_1 = require("@mui/icons-material/Edit");
var Cross_Icon_Button_1 = require("../../../common/buttons/Cross_Icon_Button");
var Checked_Icon__Button_1 = require("../../../common/buttons/Checked_Icon _Button");
var array_helpers_1 = require("../../../utils/array_helpers");
var menu_constants_1 = require("../../../menuList/menu_constants");
var text_filed_component_1 = require("../../../common/text_filed/text_filed_component");
var SystemConfiguration = function () {
    var features = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.SYSTEM_CONFIGURATION);
    var _a = React.useState(), initialValues = _a[0], setInitialValues = _a[1];
    var formSubmitHandler = function (values, setFieldValue, key) {
        var payload = {
            id: Number(values.id),
            value: values.temporaryValue,
        };
        (0, system_configuration_api_calls_1.submitTimesGaps)(payload)
            .then(function (response) {
            if (response.status === 200) {
                setFieldValue("".concat(key, ".isEdit"), false);
            }
        });
    };
    var fetchOndemandFields = function (isMounted) {
        var privateListAccess = features[menu_constants_1.FEATURE_CONSTANTS.SYSTEM_PRIVATE_CONFIG] ? 1 : 0;
        var payload = {
            show_all: privateListAccess
        };
        (0, system_configuration_api_calls_1.fetchOndemandTimeGaps)(payload)
            .then(function (response) {
            if (!isMounted)
                return;
            var updatedInitialvalues = {};
            response.forEach(function (fields, index) {
                var trimmedKey = fields.description.replace(/ /g, "");
                fields['isEdit'] = false;
                fields['temporaryValue'] = fields.svalue;
                updatedInitialvalues[trimmedKey] = fields;
            });
            setInitialValues(updatedInitialvalues);
        })
            .catch(function (err) {
            if (isMounted) {
                console.log(err);
            }
        });
    };
    React.useEffect(function () {
        var isMounted = true;
        fetchOndemandFields(isMounted);
        return function () {
            isMounted = false;
        };
    }, []);
    return (React.createElement(formik_1.Formik, { initialValues: __assign({}, initialValues), validateOnBlur: false, enableReinitialize: true, onSubmit: function () { } }, function (_a) {
        var errors = _a.errors, values = _a.values, setFieldValue = _a.setFieldValue, setFieldTouched = _a.setFieldTouched, touched = _a.touched;
        return (React.createElement(formik_1.Form, { id: "myForm", className: "input-fileds-wrapper system-config-wrapper" },
            React.createElement("div", { className: "tool-bar-wrapper border-bottom no-filter-toolbar" },
                React.createElement("div", { className: "page-heaidng heading-return-wrapper" },
                    React.createElement("h2", null, "System Configurations"))),
            React.createElement(Grid_1.default, { container: true, className: 'form-filed-wrapper' },
                React.createElement(Grid_1.default, { item: true, container: true, xs: 12, columnSpacing: 3 },
                    React.createElement(Grid_1.default, { item: true, xs: 8 },
                        React.createElement("p", { className: 'config-label' }, "Description")),
                    React.createElement(Grid_1.default, { item: true, xs: 4 },
                        React.createElement("p", { className: 'config-label' }, "Value"))),
                React.createElement(formik_1.FieldArray, { name: "applications" }, function (_a) {
                    var remove = _a.remove;
                    return (Object.entries(values).map(function (_a) {
                        var key = _a[0];
                        return (React.createElement(Grid_1.default, { item: true, container: true, xs: 12, columnSpacing: 3, key: key, className: 'config-wrapper' },
                            React.createElement(Grid_1.default, { item: true, xs: 8, style: { display: 'flex', alignItems: 'center' } },
                                React.createElement("h2", { className: "label-heading heading" }, values[key].description)),
                            React.createElement(Grid_1.default, { item: true, container: true, xs: 4 },
                                React.createElement(Grid_1.default, { item: true, xs: 9, className: 'textfield-wrapper' },
                                    React.createElement(text_filed_component_1.default, { name: key, value: values[key].temporaryValue, onChange: function (val) {
                                            setFieldValue("".concat(key, ".temporaryValue"), val);
                                            setFieldTouched(values[key].temporaryValue, true);
                                        }, isDisabled: !values[key].isEdit, required: true }),
                                    errors[values[key]] && touched[values[key]] ? (React.createElement("div", { className: "error" },
                                        errors[values[key]],
                                        " ")) : null),
                                React.createElement(Grid_1.default, { item: true, xs: 2, style: { display: 'flex', alignItems: 'center', marginLeft: '15px' } },
                                    !values[key].isEdit &&
                                        React.createElement(material_1.IconButton, { className: "icon-btn", onClick: function () {
                                                setFieldValue("".concat(key, ".isEdit"), true);
                                            } },
                                            React.createElement(Edit_1.default, { sx: { fontSize: '27px' } })),
                                    values[key].isEdit &&
                                        React.createElement(React.Fragment, null,
                                            React.createElement(Cross_Icon_Button_1.default, { onClick: function () {
                                                    setFieldValue("".concat(key, ".temporaryValue"), values[key].svalue);
                                                    setFieldValue("".concat(key, ".isEdit"), false);
                                                } }),
                                            React.createElement(Checked_Icon__Button_1.default, { onClick: function () { formSubmitHandler(values[key], setFieldValue, key); } }))))));
                    }));
                }))));
    }));
};
exports.default = SystemConfiguration;
